// removed by extract-text-webpack-plugin
module.exports = {"container":"container_SubjectPlaceHolder","title-box":"title-box_SubjectPlaceHolder","titleBox":"title-box_SubjectPlaceHolder","feed-title":"feed-title_SubjectPlaceHolder","feedTitle":"feed-title_SubjectPlaceHolder"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SubjectPlaceHolder/SubjectPlaceHolder.scss
// module id = 272
// module chunks = 0